/* Pénombre — core interactions (no framework, no external deps) */
(function(){
  "use strict";

  function pushEvent(name, data){
    window.lumaDataLayer = window.lumaDataLayer || [];
    window.lumaDataLayer.push(Object.assign({ event: name }, data || {}));
  }
  window.lumaPushEvent = pushEvent;

  function formatMoney(cents){
    var amount = (cents / 100).toFixed(2).replace('.', ',');
    return amount + ' €';
  }
  window.lumaFormatMoney = formatMoney;

  function showToast(msg){
    var toast = document.getElementById('luma-toast');
    if(!toast) return;
    toast.textContent = msg;
    toast.classList.add('is-visible');
    clearTimeout(toast._t);
    toast._t = setTimeout(function(){ toast.classList.remove('is-visible'); }, 2600);
  }
  window.lumaToast = showToast;

  function initHeroReveal(){
    if(!document.querySelector('.hero')) return;
    try{ sessionStorage.setItem('luma_hero_seen', '1'); } catch(e){ }
  }

  function initAnnouncementBar(){
    var bar = document.querySelector('[data-announcement-bar]');
    if(!bar) return;
    var slides = Array.prototype.slice.call(bar.querySelectorAll('.announcement-bar__slide'));
    if(slides.length < 2) return;
    if(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var baseInterval = (parseInt(bar.getAttribute('data-interval'), 10) || 5) * 1000;
    var featuredMultiplier = parseFloat(bar.getAttribute('data-featured-multiplier')) || 3;
    var current = 0;
    var timer;
    var paused = false;

    function durationFor(slide){
      return slide.classList.contains('announcement-bar__slide--featured') ? baseInterval * featuredMultiplier : baseInterval;
    }
    function advance(){
      slides[current].classList.remove('is-active');
      current = (current + 1) % slides.length;
      slides[current].classList.add('is-active');
      schedule();
    }
    function schedule(){
      clearTimeout(timer);
      if(paused) return;
      timer = setTimeout(advance, durationFor(slides[current]));
    }
    function start(){ paused = false; schedule(); }
    function stop(){ paused = true; clearTimeout(timer); }
    schedule();
    bar.addEventListener('mouseenter', stop);
    bar.addEventListener('mouseleave', start);
  }

  function initAnnouncementReveal(){
    document.querySelectorAll('[data-announcement-reveal]').forEach(function(btn){
      btn.addEventListener('click', function(e){
        e.preventDefault();
        if(btn.getAttribute('data-revealed') === '1') return;
        var code = btn.getAttribute('data-code');
        if(code && navigator.clipboard && navigator.clipboard.writeText){
          navigator.clipboard.writeText(code).catch(function(){});
        }
        btn.textContent = btn.getAttribute('data-label-revealed');
        btn.setAttribute('data-revealed', '1');
        if(code){ showToast('Code ' + code + ' copié — collez-le au moment de payer.'); }
      });
    });
  }

  /* Compte à rebours honnête : lit une VRAIE date de fin (réglage de section, jamais
     inventée), se recalcule au chargement et ne se remet jamais à zéro. Utilisé pour
     la barre d'annonce et la fiche produit. La ligne parente (.promo-countdown-line)
     est masquée une fois la date passée, plutôt que d'afficher un compteur à zéro. */
  function initPromoCountdown(){
    document.querySelectorAll('[data-promo-countdown]').forEach(function(el){
      var endStr = el.getAttribute('data-promo-countdown');
      var end = new Date(endStr).getTime();
      if(isNaN(end)) return;
      var line = el.closest('.promo-countdown-line');
      function tick(){
        var diff = end - Date.now();
        if(diff <= 0){
          el.textContent = '';
          if(line) line.style.display = 'none';
          return;
        }
        var d = Math.floor(diff / 86400000);
        var h = Math.floor((diff % 86400000) / 3600000);
        var m = Math.floor((diff % 3600000) / 60000);
        var parts = [];
        if(d > 0) parts.push(d + ' j');
        parts.push(h + ' h');
        parts.push(m + ' min');
        el.textContent = parts.join(' ');
      }
      tick();
      setInterval(tick, 60000);
    });
  }

  function initTrustStatements(){
    var root = document.querySelector('[data-trust-statements]');
    if(!root) return;
    var slides = root.querySelectorAll('.ts__slide');
    var dots = root.querySelectorAll('[data-ts-dot]');
    if(slides.length < 2) return;
    if(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var interval = (parseInt(root.getAttribute('data-interval'), 10) || 6) * 1000;
    var current = 0;
    var timer;
    function show(i){
      slides[current].classList.remove('is-active');
      if(dots[current]) dots[current].classList.remove('is-active');
      current = i;
      slides[current].classList.add('is-active');
      if(dots[current]) dots[current].classList.add('is-active');
    }
    function advance(){ show((current + 1) % slides.length); }
    function start(){ timer = setInterval(advance, interval); }
    function stop(){ clearInterval(timer); }
    start();
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    dots.forEach(function(dot, idx){
      dot.addEventListener('click', function(){ stop(); show(idx); start(); });
    });
  }

  function initHeader(){
    var header = document.querySelector('.site-header');
    if(header){
      var onScroll = function(){ header.classList.toggle('is-scrolled', window.scrollY > 8); };
      onScroll();
      window.addEventListener('scroll', onScroll, { passive:true });
    }
    var toggle = document.querySelector('.nav-toggle');
    var nav = document.querySelector('.site-nav');
    var scrim = document.querySelector('.nav-scrim');
    if(toggle && nav){
      var close = function(){
        nav.classList.remove('is-open');
        if(scrim) scrim.classList.remove('is-visible');
        toggle.setAttribute('aria-expanded','false');
        document.body.style.overflow = '';
      };
      toggle.addEventListener('click', function(){
        var open = nav.classList.toggle('is-open');
        if(scrim) scrim.classList.toggle('is-visible', open);
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        document.body.style.overflow = open ? 'hidden' : '';
      });
      if(scrim) scrim.addEventListener('click', close);
      nav.querySelectorAll('a').forEach(function(a){ a.addEventListener('click', close); });
    }

    document.querySelectorAll('.site-nav__dropdown-trigger').forEach(function(trigger){
      trigger.addEventListener('click', function(e){
        if(window.innerWidth >= 990) return;
        e.preventDefault();
        var dropdown = trigger.closest('.site-nav__dropdown');
        var open = dropdown.classList.toggle('is-open');
        trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  var Cart = (function(){
    var drawer = null, itemsEl = null, subtotalEl = null, countEls = [], shippingBar = null;
    var FREE_SHIPPING_THRESHOLD = 4900; /* 49,00 € */

    function init(){
      drawer = document.querySelector('[data-cart-drawer]');
      if(!drawer) return;
      itemsEl = drawer.querySelector('[data-cart-items]');
      subtotalEl = drawer.querySelector('[data-cart-subtotal]');
      shippingBar = drawer.querySelector('[data-cart-shipping-bar]');
      countEls = Array.prototype.slice.call(document.querySelectorAll('[data-cart-count]'));

      document.querySelectorAll('[data-cart-open]').forEach(function(btn){
        btn.addEventListener('click', function(e){ e.preventDefault(); open(); refresh(); });
      });
      document.querySelectorAll('[data-cart-close]').forEach(function(btn){
        btn.addEventListener('click', function(e){ e.preventDefault(); close(); });
      });

      document.addEventListener('submit', function(e){
        var form = e.target.closest('form[data-product-form]');
        if(!form) return;
        e.preventDefault();
        addFromForm(form);
      });

      itemsEl && itemsEl.addEventListener('click', function(e){
        var removeBtn = e.target.closest('[data-line-remove]');
        if(removeBtn){ changeLine(removeBtn.getAttribute('data-line-remove'), 0); }
        var minus = e.target.closest('[data-line-minus]');
        if(minus){ stepLine(minus, -1); }
        var plus = e.target.closest('[data-line-plus]');
        if(plus){ stepLine(plus, 1); }
      });

      refresh();
    }

    function stepLine(btn, delta){
      var wrap = btn.closest('[data-line-key]');
      var key = wrap.getAttribute('data-line-key');
      var input = wrap.querySelector('[data-line-qty]');
      var next = Math.max(0, parseInt(input.value || '1', 10) + delta);
      changeLine(key, next);
    }

    function open(){
      drawer.classList.add('is-open');
      var scrim = document.querySelector('[data-cart-scrim]');
      if(scrim) scrim.classList.add('is-visible');
      document.body.style.overflow = 'hidden';
    }
    function close(){
      drawer.classList.remove('is-open');
      var scrim = document.querySelector('[data-cart-scrim]');
      if(scrim) scrim.classList.remove('is-visible');
      document.body.style.overflow = '';
    }
    window.lumaOpenCart = open;

    function addFromForm(form){
      var fd = new FormData(form);
      var submitBtn = form.querySelector('[type="submit"]');
      if(submitBtn){ submitBtn.disabled = true; submitBtn.classList.add('is-loading'); }
      fetch('/cart/add.js', { method:'POST', body: fd, headers: { 'Accept':'application/json' } })
        .then(function(r){ return r.json(); })
        .then(function(item){
          if(item.status){ throw item; }
          pushEvent('add_to_cart', { items:[{ id:item.id, product_id:item.product_id, price:item.price/100, quantity:item.quantity }] });
          showToast('Ajouté au panier — ' + item.product_title);
          open();
          refresh();
        })
        .catch(function(err){
          showToast((err && err.description) || 'Cet article n\'a pas pu être ajouté.');
        })
        .finally(function(){
          if(submitBtn){ submitBtn.disabled = false; submitBtn.classList.remove('is-loading'); }
        });
    }
    window.lumaAddToCart = addFromForm;

    function changeLine(key, qty){
      fetch('/cart/change.js', {
        method:'POST',
        headers:{ 'Content-Type':'application/json', 'Accept':'application/json' },
        body: JSON.stringify({ id:key, quantity:qty })
      }).then(function(r){ return r.json(); }).then(render);
    }

    function refresh(){
      fetch('/cart.js', { headers:{ 'Accept':'application/json' } }).then(function(r){ return r.json(); }).then(render);
    }
    window.lumaRefreshCart = refresh;

    function updateShippingBar(cart){
      if(!shippingBar) return;
      var textEl = shippingBar.querySelector('[data-cart-shipping-text]');
      var fillEl = shippingBar.querySelector('[data-cart-progress-fill]');
      if(cart.item_count === 0){ shippingBar.hidden = true; return; }
      shippingBar.hidden = false;
      var remaining = FREE_SHIPPING_THRESHOLD - cart.total_price;
      if(remaining > 0){
        shippingBar.classList.remove('is-complete');
        if(textEl) textEl.textContent = 'Plus que ' + formatMoney(remaining) + ' pour la livraison offerte';
        if(fillEl) fillEl.style.width = Math.max(4, Math.min(100, (cart.total_price / FREE_SHIPPING_THRESHOLD) * 100)) + '%';
      } else {
        shippingBar.classList.add('is-complete');
        if(textEl) textEl.textContent = 'Livraison offerte ✓';
        if(fillEl) fillEl.style.width = '100%';
      }
    }

    function render(cart){
      countEls.forEach(function(el){
        el.textContent = cart.item_count;
        el.hidden = cart.item_count === 0;
      });
      updateShippingBar(cart);
      if(!itemsEl) return;
      if(cart.item_count === 0){
        itemsEl.innerHTML = '<div class="cart-drawer__empty">Votre panier est vide.<br><a href="/collections/all" class="link-underline">Continuer mes achats</a></div>';
      } else {
        itemsEl.innerHTML = cart.items.map(function(item){
          return '' +
            '<div class="cart-line" data-line-key="' + item.key + '">' +
              '<img src="' + (item.image || '') + '" alt="" loading="lazy" width="80" height="80">' +
              '<div style="flex:1">' +
                '<div class="cart-line__title">' + item.product_title + '</div>' +
                '<div class="cart-line__opts">' + (item.variant_title || '') + '</div>' +
                '<div class="qty-stepper" style="margin-top:8px">' +
                  '<button type="button" data-line-minus aria-label="Diminuer la quantité">−</button>' +
                  '<input data-line-qty type="text" readonly value="' + item.quantity + '">' +
                  '<button type="button" data-line-plus aria-label="Augmenter la quantité">+</button>' +
                '</div>' +
              '</div>' +
              '<div style="display:flex;flex-direction:column;align-items:flex-end;justify-content:space-between">' +
                '<button type="button" data-line-remove="' + item.key + '" aria-label="Retirer" class="icon-btn" style="width:24px;height:24px">×</button>' +
                '<strong>' + formatMoney(item.final_line_price) + '</strong>' +
              '</div>' +
            '</div>';
        }).join('');
      }
      if(subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
    }

    return { init: init, refresh: refresh };
  })();

  /* Stock bas */
  function updateStockBadge(root, v, stockMap){
    var badge = root.querySelector('[data-stock-badge]');
    if(!badge) return;
    var qty = (v && stockMap) ? stockMap[String(v.id)] : undefined;
    if(typeof qty !== 'number'){ badge.hidden = true; badge.textContent = ''; return; }
    badge.hidden = false;
    badge.textContent = qty === 1
      ? ('Il reste 1 exemplaire en ' + v.title + '.')
      : ('Peu d\'unités restantes en ' + v.title + ' (' + qty + ').');
  }

  function imageFileKey(src){
    if(!src) return '';
    return src.split('?')[0].split('/').pop();
  }

  function initProductForms(){
    document.querySelectorAll('[data-product-root]').forEach(function(root){
      var variantsJson = root.querySelector('[data-variants-json]');
      if(!variantsJson) return;
      var variants;
      try { variants = JSON.parse(variantsJson.textContent); } catch(e){ return; }

      var stockMapEl = root.querySelector('[data-stock-map]');
      var stockMap = {};
      if(stockMapEl){ try { stockMap = JSON.parse(stockMapEl.textContent); } catch(e){ stockMap = {}; } }

      var optionInputs = root.querySelectorAll('[data-option-index]');
      var priceEl = root.querySelector('[data-price]');
      var comparePriceEl = root.querySelector('[data-compare-price]');
      var idInput = root.querySelector('[data-variant-id]');
      var submitBtn = root.querySelector('[data-add-to-cart]');
      var mainImg = root.querySelector('[data-gallery-main-img]');

      function currentSelection(){
        var sel = [];
        optionInputs.forEach(function(input){
          if(input.type === 'radio' && !input.checked) return;
          sel[parseInt(input.getAttribute('data-option-index'), 10)] = input.value;
        });
        return sel;
      }

      function findVariant(){
        var sel = currentSelection();
        return variants.filter(function(v){
          return v.options.every(function(opt, i){ return sel[i] === undefined || opt === sel[i]; });
        })[0];
      }

      function syncThumbnails(activeSrc){
        if(!activeSrc) return;
        var key = imageFileKey(activeSrc);
        root.querySelectorAll('[data-thumb]').forEach(function(thumb){
          var tImg = thumb.querySelector('img');
          thumb.classList.toggle('is-active', tImg && imageFileKey(tImg.src) === key);
        });
      }

      function update(){
        var v = findVariant();
        if(!v) return;
        if(idInput) idInput.value = v.id;
        if(priceEl) priceEl.textContent = formatMoney(v.price);
        if(comparePriceEl){
          if(v.compare_at_price && v.compare_at_price > v.price){
            comparePriceEl.textContent = formatMoney(v.compare_at_price);
            comparePriceEl.hidden = false;
          } else { comparePriceEl.hidden = true; }
        }
        if(submitBtn){
          submitBtn.disabled = !v.available;
          submitBtn.querySelector('[data-add-label]') && (submitBtn.querySelector('[data-add-label]').textContent = v.available ? (submitBtn.getAttribute('data-label-available') || 'Ajouter au panier') : 'Épuisé');
        }
        if(mainImg && v.featured_image && v.featured_image.src){
          mainImg.src = v.featured_image.src;
          syncThumbnails(v.featured_image.src);
        }
        updateStockBadge(root, v, stockMap);
        root.querySelectorAll('[data-option-index]').forEach(function(input){
          var group = parseInt(input.getAttribute('data-option-index'), 10);
          var value = input.value;
          var testSel = currentSelection().slice();
          testSel[group] = value;
          var exists = variants.some(function(vv){
            return vv.options.every(function(opt, i){ return testSel[i] === undefined || opt === testSel[i]; }) && vv.available;
          });
          input.disabled = !exists;
          var label = input.closest('.swatch');
          if(label) label.classList.toggle('is-selected', input.checked);
        });

        var sel = currentSelection();
        root.querySelectorAll('[data-pm-selected]').forEach(function(span){
          var idx = parseInt(span.getAttribute('data-pm-selected'), 10);
          if(sel[idx] !== undefined) span.textContent = sel[idx];
        });
      }

      optionInputs.forEach(function(input){ input.addEventListener('change', update); });
      update();

      var stepper = root.querySelector('[data-qty-stepper]');
      if(stepper){
        var qtyInput = stepper.querySelector('input');
        stepper.querySelector('[data-qty-minus]').addEventListener('click', function(){
          qtyInput.value = Math.max(1, (parseInt(qtyInput.value,10)||1) - 1);
        });
        stepper.querySelector('[data-qty-plus]').addEventListener('click', function(){
          qtyInput.value = (parseInt(qtyInput.value,10)||1) + 1;
        });
      }
    });

    var stickyBar = document.querySelector('[data-sticky-atc]');
    var anchor = document.querySelector('[data-atc-anchor]');
    if(stickyBar && anchor && 'IntersectionObserver' in window){
      var io = new IntersectionObserver(function(entries){
        stickyBar.classList.toggle('is-visible', !entries[0].isIntersecting);
      }, { rootMargin: '-120px 0px 0px 0px' });
      io.observe(anchor);
      var stickyBtn = stickyBar.querySelector('[data-sticky-add]');
      if(stickyBtn){
        stickyBtn.addEventListener('click', function(){
          var form = document.querySelector('[data-product-form]');
          if(form) window.lumaAddToCart(form);
        });
      }
    }
  }

  function initFaq(){
    document.querySelectorAll('.faq-item__q').forEach(function(btn){
      btn.addEventListener('click', function(){
        var item = btn.closest('.faq-item');
        var wasOpen = item.classList.contains('is-open');
        item.parentElement.querySelectorAll('.faq-item.is-open').forEach(function(el){
          if(el !== item){ el.classList.remove('is-open'); el.querySelector('.faq-item__q').setAttribute('aria-expanded','false'); }
        });
        item.classList.toggle('is-open', !wasOpen);
        btn.setAttribute('aria-expanded', !wasOpen ? 'true' : 'false');
      });
    });
  }

  function initBeforeAfter(){
    document.querySelectorAll('[data-before-after]').forEach(function(el){
      var after = el.querySelector('.before-after__after');
      var handle = el.querySelector('.before-after__handle');
      var img = after ? after.querySelector('img') : null;
      var dragging = false;

      function setPos(clientX){
        var rect = el.getBoundingClientRect();
        var pct = Math.min(100, Math.max(0, ((clientX - rect.left) / rect.width) * 100));
        after.style.width = pct + '%';
        handle.style.left = pct + '%';
        if(img) img.style.width = (10000 / pct) + '%';
      }

      el.addEventListener('pointerdown', function(e){ dragging = true; setPos(e.clientX); });
      window.addEventListener('pointermove', function(e){ if(dragging) setPos(e.clientX); });
      window.addEventListener('pointerup', function(){ dragging = false; });
      el.addEventListener('touchmove', function(e){ if(e.touches[0]) setPos(e.touches[0].clientX); }, { passive:true });
    });
  }

  function initQuiz(){
    function parseOccultantSize(sizeStr){
      var m = /W(\d+)xH(\d+)/i.exec(sizeStr || '');
      return m ? { w: parseInt(m[1], 10), h: parseInt(m[2], 10) } : null;
    }
    function parseVoilageHeight(sizeStr){
      var m = /\d+x(\d+)/i.exec(sizeStr || '');
      return m ? parseInt(m[1], 10) : null;
    }
    function preferAvailable(list){
      var avail = list.filter(function(v){ return v.available; });
      return avail.length ? avail : list;
    }
    function pickOccultantVariant(variants, width, height, colorLabel){
      var desiredPanneaux = (width != null && width >= 150) ? '2 panneaux' : '1 panneau';
      var pool = variants.filter(function(v){ return v.option1 === colorLabel && v.option3 === desiredPanneaux; });
      if(!pool.length) pool = variants.filter(function(v){ return v.option1 === colorLabel; });
      if(!pool.length) pool = variants.slice();
      pool = preferAvailable(pool);
      var best = null, bestScore = Infinity;
      pool.forEach(function(v){
        var size = parseOccultantSize(v.option2);
        if(!size) return;
        var dw = width != null ? (size.w - width) : 0;
        var dh = height != null ? (size.h - height) : 0;
        var score = (dw * dw) + (dh * dh);
        if(score < bestScore){ bestScore = score; best = v; }
      });
      return best || pool[0] || null;
    }
    function pickVoilageVariant(variants, height){
      var pool = variants.filter(function(v){ return v.option3 === 'Œillets'; });
      if(!pool.length) pool = variants.slice();
      pool = preferAvailable(pool);
      if(height == null) return pool[0] || null;
      var best = null, bestScore = Infinity;
      pool.forEach(function(v){
        var h = parseVoilageHeight(v.option2);
        if(h == null) return;
        var score = Math.abs(h - height);
        if(score < bestScore){ bestScore = score; best = v; }
      });
      return best || pool[0] || null;
    }

    document.querySelectorAll('[data-quiz]').forEach(function(root){
      var catalogEl = root.querySelector('[data-quiz-catalog]');
      var catalog = {};
      if(catalogEl){
        try { catalog = JSON.parse(catalogEl.textContent); } catch(e){ catalog = {}; }
      }
      var steps = Array.prototype.slice.call(root.querySelectorAll('[data-quiz-step]'));
      var dots = Array.prototype.slice.call(root.querySelectorAll('.quiz__progress-dot'));
      var current = 0;
      var answers = { goal:null, room:null, width:null, height:null, style:null, level:null };
      var started = false;

      function show(i){
        steps.forEach(function(s, idx){ s.classList.toggle('is-active', idx === i); });
        dots.forEach(function(d, idx){ d.classList.toggle('is-active', idx <= i); });
        current = i;
      }
      show(0);

      root.querySelectorAll('[data-quiz-option]').forEach(function(btn){
        btn.addEventListener('click', function(){
          if(!started){ started = true; pushEvent('quiz_start', {}); }
          var field = btn.getAttribute('data-field');
          answers[field] = btn.getAttribute('data-value');
          btn.parentElement.querySelectorAll('[data-quiz-option]').forEach(function(b){ b.classList.remove('is-selected'); });
          btn.classList.add('is-selected');
          setTimeout(function(){
            if(current < steps.length - 1){ show(current + 1); }
          }, 220);
        });
      });

      var dimsNext = root.querySelector('[data-quiz-dims-next]');
      if(dimsNext){
        dimsNext.addEventListener('click', function(){
          var w = root.querySelector('[data-field="width"]');
          var h = root.querySelector('[data-field="height"]');
          answers.width = w ? w.value : null;
          answers.height = h ? h.value : null;
          if(current < steps.length - 1){ show(current + 1); }
        });
      }

      root.querySelectorAll('[data-quiz-back]').forEach(function(btn){
        btn.addEventListener('click', function(){ if(current > 0) show(current - 1); });
      });

      var resultStep = root.querySelector('[data-quiz-result]');
      if(resultStep){
        var lastInputStep = steps.indexOf(resultStep) - 1;
      }

      root.addEventListener('click', function(e){
        var finishBtn = e.target.closest('[data-quiz-finish]');
        if(!finishBtn) return;
        var field = finishBtn.getAttribute('data-field');
        if(field) answers[field] = finishBtn.getAttribute('data-value');
        renderResult();
      });

      function renderResult(){
        var config = recommend(answers);
        var out = root.querySelector('[data-quiz-result]');
        if(out){
          var titleEl = out.querySelector('[data-rec-title]');
          if(titleEl && config.title) titleEl.textContent = config.title;
          out.querySelector('[data-rec-color]').textContent = config.color;
          out.querySelector('[data-rec-level]').textContent = config.level;
          out.querySelector('[data-rec-reason]').textContent = config.reason;
          var priceEl = out.querySelector('[data-rec-price]');
          if(priceEl){ priceEl.textContent = config.price != null ? ('à partir de ' + formatMoney(config.price)) : ''; }
          out.querySelectorAll('[data-rec-badge]').forEach(function(b){
            b.style.display = (b.getAttribute('data-rec-badge') === config.productKey) ? 'flex' : 'none';
          });
          var link = out.querySelector('[data-rec-link]');
          if(link) link.href = config.url;
          show(steps.length - 1);
          pushEvent('quiz_complete', { goal: answers.goal, room: answers.room, level: answers.level, recommended_product: config.title });
        }
      }

      function recommend(a){
        var wantsVoilage = a.goal === 'privacy' && catalog.voilage && catalog.voilage.variants && catalog.voilage.variants.length;
        var product = wantsVoilage ? catalog.voilage : catalog.occultant;

        var level = 'Confort';
        if(a.level === 'essential') level = 'Essentiel';
        if(a.level === 'premium') level = 'Premium';

        var roomLabels = {
          'bedroom': 'les chambres',
          'living room': 'les salons',
          'office': 'les bureaux',
          'baby room': 'les chambres d\'enfant',
          'entire home': 'toute la maison'
        };
        var roomText = roomLabels[a.room] || 'votre pièce';

        var reasonParts = [];
        if(wantsVoilage){
          reasonParts.push('une intimité en douceur, sans fermer complètement la pièce à la lumière');
        } else {
          if(a.goal === 'sunlight' || a.goal === 'sleep' || a.goal === 'everything') reasonParts.push('une obscurité profonde pour contrôler la lumière');
          if(a.goal === 'heat') reasonParts.push('un tissage thermique conçu pour le confort près des fenêtres');
          if(a.goal === 'everything') reasonParts.push('une chute plus généreuse pour l\'intimité');
          if(a.goal === 'noise') reasonParts.push('un tissu plus lourd qui atténue le bruit extérieur');
        }
        var reason = 'Conçu pour ' + roomText + ', où ' + (reasonParts.join(' et ') || 'le confort au quotidien') + ' compte le plus.';

        var width = a.width ? parseFloat(a.width) : null;
        var height = a.height ? parseFloat(a.height) : null;

        if(!product || !product.variants || !product.variants.length){
          var base = root.getAttribute('data-product-url') || '/products/penombre-rideau-thermique-occultant';
          var params = new URLSearchParams();
          if(a.width) params.set('w', a.width);
          if(a.height) params.set('h', a.height);
          return { title: null, color: 'Beige', level: level, reason: reason, price: null, productKey: 'occultant', url: base + '?' + params.toString() };
        }

        var color, variant;
        if(wantsVoilage){
          color = 'Ivoire Chaud';
          variant = pickVoilageVariant(product.variants, height);
        } else {
          color = 'Beige';
          if(a.style === 'minimal') color = 'Gris';
          else if(a.style === 'modern') color = 'Noir';
          variant = pickOccultantVariant(product.variants, width, height, color);
        }

        var url = product.url + '?discount=WELCOME10';
        if(variant) url = product.url + '?variant=' + variant.id + '&discount=WELCOME10';

        return {
          title: product.title,
          color: color,
          level: level,
          reason: reason,
          price: variant ? variant.price : null,
          productKey: wantsVoilage ? 'voilage' : 'occultant',
          url: url
        };
      }
    });
  }

  function initEmailPopup(){
    var popup = document.querySelector('[data-email-popup]');
    var scrim = document.querySelector('[data-email-popup-scrim]');
    if(!popup) return;
    var STORAGE_KEY = 'luma_email_popup_shown';

    function reveal(){
      if(sessionStorage.getItem(STORAGE_KEY)) return;
      sessionStorage.setItem(STORAGE_KEY, '1');
      popup.classList.add('is-visible');
      if(scrim) scrim.classList.add('is-visible');
    }
    function dismiss(){
      popup.classList.remove('is-visible');
      if(scrim) scrim.classList.remove('is-visible');
    }

    popup.querySelectorAll('[data-email-popup-close]').forEach(function(b){ b.addEventListener('click', dismiss); });
    if(scrim) scrim.addEventListener('click', dismiss);

    setTimeout(reveal, 5000);
    document.addEventListener('mouseout', function(e){
      if(!e.relatedTarget && e.clientY < 8) reveal();
    });

    var form = popup.querySelector('form');
    if(form){
      form.addEventListener('submit', function(e){
        e.preventDefault();
        var fd = new FormData(form);
        fetch(form.action, { method:'POST', body: fd, headers:{ 'Accept':'application/json' } })
          .then(function(){
            popup.classList.add('is-success');
            pushEvent('email_signup', {});
          })
          .catch(function(){ showToast('Une erreur est survenue — veuillez réessayer.'); });
      });
    }
  }

  function initContactWidget(){
    var root = document.querySelector('[data-contact-widget]');
    if(!root) return;
    var toggle = root.querySelector('[data-contact-toggle]');
    var closeBtn = root.querySelector('[data-contact-close]');
    var catButtons = root.querySelectorAll('[data-contact-cat]');
    var catInput = root.querySelector('[data-contact-category-input]');
    var bodyField = root.querySelector('[data-contact-body]');
    var form = root.querySelector('form');

    function open(){
      root.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');
    }
    function close(){
      root.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
    }
    toggle.addEventListener('click', function(){
      root.classList.contains('is-open') ? close() : open();
    });
    if(closeBtn) closeBtn.addEventListener('click', close);
    document.addEventListener('keydown', function(e){
      if(e.key === 'Escape' && root.classList.contains('is-open')) close();
    });
    document.addEventListener('click', function(e){
      var trigger = e.target.closest('[data-open-contact-widget]');
      if(trigger){
        e.preventDefault();
        open();
        var wantedCat = trigger.getAttribute('data-contact-cat');
        if(wantedCat){
          var match = null;
          catButtons.forEach(function(b){ if(b.getAttribute('data-contact-cat') === wantedCat){ match = b; } });
          if(match) match.click();
          if(bodyField) bodyField.focus();
        }
      }
    });

    catButtons.forEach(function(btn){
      btn.addEventListener('click', function(){
        catButtons.forEach(function(b){ b.classList.remove('is-selected'); b.setAttribute('aria-pressed', 'false'); });
        btn.classList.add('is-selected');
        btn.setAttribute('aria-pressed', 'true');
        if(catInput) catInput.value = btn.getAttribute('data-contact-cat');
      });
    });

    if(form){
      form.addEventListener('submit', function(e){
        e.preventDefault();
        if(bodyField && catInput){
          var prefix = '[' + catInput.value + '] ';
          if(bodyField.value.indexOf(prefix) !== 0){ bodyField.value = prefix + bodyField.value; }
        }
        var submitBtn = form.querySelector('[type="submit"]');
        if(submitBtn){ submitBtn.disabled = true; }
        var fd = new FormData(form);
        fetch(form.action, { method:'POST', body: fd, headers:{ 'Accept':'application/json' } })
          .then(function(){
            root.classList.add('is-success');
            pushEvent('contact_submit', { category: catInput ? catInput.value : '' });
          })
          .catch(function(){ showToast('Une erreur est survenue — veuillez réessayer.'); })
          .finally(function(){
            if(submitBtn){ submitBtn.disabled = false; }
          });
      });
    }
  }

  function initViewItem(){
    var root = document.querySelector('[data-product-root]');
    if(root){
      pushEvent('view_item', {
        item_id: root.getAttribute('data-product-id'),
        item_name: root.getAttribute('data-product-title'),
        price: root.getAttribute('data-product-price')
      });
    }
  }

  /* ---------------------------------------------------------------- */
  /* Collection filters: accordion, auto-submit, mobile drawer         */
  /* ---------------------------------------------------------------- */
  function initPlpFilters(){
    var form = document.getElementById('FacetFiltersForm');
    if(!form) return;

    function submitForm(){
      if(form.requestSubmit){ form.requestSubmit(); } else { form.submit(); }
    }

    form.addEventListener('change', function(e){
      if(e.target.matches('input[type="checkbox"], input[type="number"]')){ submitForm(); }
    });

    var sort = document.querySelector('[data-plp-sort]');
    if(sort){ sort.addEventListener('change', submitForm); }

    document.querySelectorAll('[data-plp-facet-toggle]').forEach(function(btn){
      btn.addEventListener('click', function(){
        btn.closest('[data-plp-facet]').classList.toggle('is-open');
      });
    });

    var sidebar = document.querySelector('[data-plp-sidebar]');
    var scrim = document.querySelector('[data-plp-scrim]');
    var openBtn = document.querySelector('[data-plp-open]');
    var closeBtn = document.querySelector('[data-plp-sidebar-close]');

    function openSidebar(){
      if(sidebar){ sidebar.classList.add('is-open'); }
      if(scrim){ scrim.classList.add('is-visible'); }
      document.body.style.overflow = 'hidden';
    }
    function closeSidebar(){
      if(sidebar){ sidebar.classList.remove('is-open'); }
      if(scrim){ scrim.classList.remove('is-visible'); }
      document.body.style.overflow = '';
    }
    if(openBtn) openBtn.addEventListener('click', openSidebar);
    if(closeBtn) closeBtn.addEventListener('click', closeSidebar);
    if(scrim) scrim.addEventListener('click', closeSidebar);
  }

  document.addEventListener('DOMContentLoaded', function(){
    initHeroReveal();
    initAnnouncementBar();
    initAnnouncementReveal();
    initPromoCountdown();
    initTrustStatements();
    initHeader();
    Cart.init();
    initProductForms();
    initFaq();
    initBeforeAfter();
    initQuiz();
    initEmailPopup();
    initContactWidget();
    initViewItem();
    initPlpFilters();
  });
})();
